module.exports = __webpack_public_path__ + "media/images/marketing/mitrovic-88f36385dae9d782d0292f13122c998d48a18891f16dad5b303768a51f366673.jpg";